export default __webpack_public_path__ + "static/media/csv-down.d180c715.svg";